import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {useSuspenseInfiniteQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import {MAIN_TRIP_SIZE, TripTab} from '@di-shared/features/safe-driving/kr/SafeDrivingMainTrip.kr';
import {DEFAULT_CACHE_TIME} from '@di-shared/const';

export interface SafeDrivingNightKrProps {
  vin: string;
  nightDrvCount: number;
}

function SafeDrivingNightKr({vin, nightDrvCount}: SafeDrivingNightKrProps) {
  const {t} = useInferableTranslation();
  const {data: mainTripData} = useSuspenseInfiniteQuery({
    queryKey: [getQueryKey(diApi.driveHistory.getMainTrip), vin, TripTab.RECKLESS_DRIVING],
    queryFn: ({pageParam}) =>
      diApi.driveHistory.getMainTrip({
        vin,
        isSafe: false,
        size: MAIN_TRIP_SIZE,
        page: pageParam,
      }),
    initialPageParam: 1,
    getNextPageParam: () => {
      return undefined;
    },
    ...DEFAULT_CACHE_TIME,
  });

  return (
    <>
      {nightDrvCount > 0 && mainTripData.pages[0].data.totalDrivingCnt > 0 && (
        <div className="section_container safe_driving_night">
          <div className="section_container_header">
            <h3 className="title_xxsmall">{t('T20000')}</h3>
          </div>
          <p
            className="section_container_desc"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20136')}
          </p>

          <ul className="statistics_info_list">
            <li className="statistics_info_item">
              <span
                className="statistics_info_key"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T20137')}
              </span>
              <span className="statistics_info_val">
                <span className="statistics_info_number">{mainTripData.pages[0].data.totalDrivingCnt}</span>
                <span className="statistics_info_unit">{t('T20133')}</span>
              </span>
            </li>
            <li className="statistics_info_item">
              <span
                className="statistics_info_key"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T20138')}
              </span>
              <span className="statistics_info_val">
                <span className="statistics_info_number">{nightDrvCount}</span>
                <span className="statistics_info_unit">{t('T20133')}</span>
              </span>
            </li>
          </ul>
        </div>
      )}
    </>
  );
}

export default SafeDrivingNightKr;
